// @flow strict
import { Button } from './Button';
import { SubmitButton } from './SubmitButton';
import type { Variant, Type, LinkVariant, IconPosition } from './Button.types';

export type ButtonType = typeof Button;
export { Button, SubmitButton };
export type { Variant, Type, LinkVariant, IconPosition };
